import React from 'react';
import { useNavigate } from "react-router-dom";
import { IconX } from "@tabler/icons-react";
import { notifications } from '@mantine/notifications';
import { Button } from '@mantine/core';
import TestsApi from "../../api/TestsApi";

export function PreviewStats({
    SelectedThumbnail,
    SystemUsageLoader,
    SelectedMemberWebsite,
  }:any) {

  const navigate = useNavigate();

  // Opens the Test History report of the page's winner test in preview mode. The
  // snapshot is written by a cron after "Set Winner"; until it lands the report
  // page shows the "coming soon" message in its table.
  const handlePreviewStats = async () => {
    try {
      SystemUsageLoader(true);
      const APIResponse = await TestsApi.checktesthistorydata({
        page_id: SelectedThumbnail,
        system_website_id: SelectedMemberWebsite,
      });
      const APIResultJSON = await APIResponse.json();
      SystemUsageLoader(false);
      if (APIResultJSON.data && APIResultJSON.data.history_id) {
        navigate('/test-history-report', { state: { historyId: APIResultJSON.data.history_id, pageId: SelectedThumbnail, previewStats: true } });
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      SystemUsageLoader(false);
      console.error("API Error:", error);
    }
  };

  return (
    <Button color="green" type="button" onClick={handlePreviewStats}>
      Preview Stats
    </Button>
  );
}
